import { module } from 'modujs';
import LsqPlayer from '../utils/vue/components/LsqPlayer'

export default class extends module {
    constructor(m) {
        super(m);

        this.src = this.getData('src')
        this.preventAside = this.getData('prevent-aside') != null
    }

    init() {

        if(!this.src) {
            return
        }

        this.app = new Vue({
            el: this.el,
            delimiters: ['${', '}'],
            components: {
                LsqPlayer
            },
            template: `
                <lsq-player src="${this.src}" preventAside="${this.preventAside}" />
            `
        })
    }

    destroy() {
        this.app?.$destroy();
    }
}

